import { type SerializedCompStructure } from '@wix/document-services-types'

import { type TimePickerData } from '../types'

export function assertTimePickerData(
  data: NonNullable<SerializedCompStructure['data']>,
): asserts data is TimePickerData {
  const TYPE: TimePickerData['type'] = 'TimePickerData'
  if (data.type !== TYPE) {
    throw new Error('Not time-picker data.')
  }
}
